"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadastroMateriaisRecursoCritico = void 0;
var bson_1 = require("bson");
var CadastroMateriaisRecursoCritico = /** @class */ (function () {
    function CadastroMateriaisRecursoCritico(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.materialType, materialType = _c === void 0 ? '' : _c, _d = _a.description, description = _d === void 0 ? '' : _d, _e = _a.modelKey, modelKey = _e === void 0 ? new Array() : _e, _f = _a.centroTrab, centroTrab = _f === void 0 ? new Array() : _f, _g = _a.subtype, subtype = _g === void 0 ? '' : _g, _h = _a.sumPvAnterior, sumPvAnterior = _h === void 0 ? false : _h, _j = _a.sumWip, sumWip = _j === void 0 ? false : _j;
        this._id = _id;
        this.materialType = materialType;
        this.description = description;
        this.modelKey = modelKey;
        this.centroTrab = centroTrab;
        this.subtype = subtype;
        this.sumPvAnterior = sumPvAnterior;
        this.sumWip = sumWip;
    }
    return CadastroMateriaisRecursoCritico;
}());
exports.CadastroMateriaisRecursoCritico = CadastroMateriaisRecursoCritico;
//# sourceMappingURL=CadastroMateriaisRecursoCritico.js.map